import { render } from "./seating.vue?vue&type=template&id=1e2a01ad&scoped=true"
import script from "./seating.vue?vue&type=script&lang=js"
export * from "./seating.vue?vue&type=script&lang=js"

import "./seating.vue?vue&type=style&index=0&id=1e2a01ad&scoped=true&lang=css"
import "./seating.vue?vue&type=style&index=1&id=1e2a01ad&lang=css"
script.render = render
script.__scopeId = "data-v-1e2a01ad"

export default script